export default class Tabs {
  state = {
    currentPanel: null,
    currentItem: null
  }

  constructor(element) {
    this._element = element;

    this._items = [...element.querySelectorAll(`.js-tabItem`)];

    this._panels = this._items.map((tab) => {
      const panelId = tab.getAttribute('href').split('#')[1];
      const panel = document.getElementById(panelId);
      if (null !== panel) {
        panel.setAttribute('hidden', '');
        panel.setAttribute('tabindex', '-1');
      }

      return panel;
    }, {});

    this.handleClick = this.clickHandler;

    this._items.map(el => {
      el.addEventListener('click', this.handleClick, true);
    })

    this.state = Object.assign({}, this.state, {
      currentPanel: this._panels[0],
      currentItem: this._items[0]
    });
    // Display first panel
    if (this._items[0] !== null) {
      this._items[0].setAttribute('aria-current', 'true');
    }
    if (this._panels[0] !== null) {
      this._panels[0].removeAttribute('hidden');
    }
  }

  clickHandler = e => {
    e.preventDefault();
    this.desactivateCurrent();
    const id = e.target.getAttribute('href').split('#')[1]
    const panel = id && document.querySelector(`#${id}`);
    if (panel) {
      e.target.setAttribute('aria-current', 'true');
      panel.removeAttribute('hidden');

      // CSD-2434 Fix mobile leaflet loads incomplete map
      const hasMap = document.getElementById('map');
      if (hasMap) {
        map.invalidateSize();
      }

      this.state = Object.assign({}, this.state, {
        currentPanel: panel,
        currentItem: e.target
      });
    }
  };

  desactivateCurrent = () => {
    if (this.state.currentPanel !== null) {
      this.state.currentPanel.setAttribute('hidden', '');
    }
    if (this.state.currentItem !== null) {
      this.state.currentItem.removeAttribute('aria-current');
    }
  }

  remove() {
    this._items.map(el => {
      el.removeEventListener('click', this.handleClick, true);
      el.removeAttribute('aria-current');
    });

    this._panels.map(el => {
      el.removeAttribute('hidden');
      el.removeAttribute('tabindex');
    });

    this.state = Object.assign({}, this.state, {
      currentPanel: null,
      currentItem: null
    });
  }
}
